import { ReactNode } from "react";
import {
  InputAdornment,
  MenuItem,
  Paper,
  SelectChangeEvent,
  styled,
} from "@mui/material";
import { Search } from "@mui/icons-material";

import { useTranslation } from "react-i18next";

import { FilterOption } from "types/types";

import { FilterSectionSelection } from "components/form/FilterSectionSelection";
import { FilterSectionTextField } from "components/form/FilterSectionTextField";

interface Props {
  search: string;
  filterOptions: FilterOption[];
  selectedFilter: FilterOption;
  setSearch: (search: string) => void;
  updateFilterSelectionParam: (filter: string) => void;
}

export function FilterMeasureSection(props: Props) {
  const {
    search,
    filterOptions,
    selectedFilter,
    setSearch,
    updateFilterSelectionParam,
  } = props;
  const { t } = useTranslation();

  function handleChange(event: SelectChangeEvent<unknown>, child: ReactNode) {
    updateFilterSelectionParam(event.target.value as string);
  }

  return (
    <StyledPaper elevation={0}>
      <FilterSectionTextField
        label={t("label.searchByName")}
        value={search}
        placeholder={"Naam"}
        onChange={(e) => setSearch(e.target.value)}
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search />
            </InputAdornment>
          ),
        }}
      />
      <FilterSectionSelection
        value={selectedFilter.value}
        onChange={handleChange}
        customLabel={t("label.sorting")}
      >
        {filterOptions.map((filterOption) => (
          <MenuItem value={filterOption.value} key={filterOption.value}>
            {filterOption.label}
          </MenuItem>
        ))}
      </FilterSectionSelection>
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(2)};
  // TODO: Not sure what's happening here...
  .MuiTooltip-root {
    padding: 100px;
  }
`;
